import getters from './getters'
import actions from './actions'
import mutations from './mutations'

// modules
import budget from './budget/index'
import agencyMargin from './agencyMargin/index'
import menu from './menu/index'

const initialState = {
  count: {
    total: 0,
    budgetRequest: 0,
    // menuRequest: 0,
    // agencyMarginRequest: 0,
    mapReportRequest: 0,
  },
}

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
  modules: {
    budget,
    agencyMargin,
    menu,
  },
}
